import React from 'react';
import { useTranslation } from 'react-i18next';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import SidebarNav from './SidebarNav';
export default function RatesSettingsLayout({ children, activeTab, account }) {
    const { t } = useTranslation();
    const getBreadcrumbs = () => {
        const name = account.name || account.account_name;
        return {
            pages: [
                {
                    name,
                    href: `/users/${account._id}`,
                    current: false,
                },
                {
                    name: t('RATE', { count: 2 }),
                    href: `/users/${account._id}/settings/rates`,
                    current: true,
                },
            ],
        };
    };
    const renderSidebar = () => {
        return React.createElement(SidebarNav, { user: account, activeTab: activeTab });
    };
    if (!account) {
        return React.createElement("p", { className: "lead" }, t('LOADING'));
    }
    return (React.createElement("div", { className: "py-4" },
        React.createElement(LayoutWithSidebar, { title: t('BILLING_SETTINGS'), breadcrumbs: getBreadcrumbs(), sidebar: renderSidebar }, children)));
}
